import { render, staticRenderFns } from "./LifeView.vue?vue&type=template&id=68dd1e60&scoped=true"
import script from "./LifeView.vue?vue&type=script&lang=js"
export * from "./LifeView.vue?vue&type=script&lang=js"
import style0 from "./LifeView.vue?vue&type=style&index=0&id=68dd1e60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dd1e60",
  null
  
)

export default component.exports